import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/policies')({
	component: Outlet,
	beforeLoad: () => ({
		getTitle: 'Policies'
	})
});
